<template>
  <button
    class="radial-checkbox"
    :style="`
      width: ${size}px;
      height: ${size}px;
      cursor: ${disabled ? 'default' : 'pointer'};`"
    @click="emit()"
  >
    <div
      v-if="color_fill"
      class="radial-checkbox-color-fill"
      :style="`
        width: ${fill_size}px;
        height: ${fill_size}px;
        background-color: ${getColor(background_color)};`"
    />
    <TransitionRotate>
      <TIcon
        v-if="is_checked"
        class="radial-checkbox-ticon"
        name="checkbox-radial-filled"
        :color="getColor(foreground_color)"
        :size="size"
        :shadow="shadow"
      />
    </TransitionRotate>
    <TransitionFade>
      <TIcon
        v-if="!is_checked"
        class="radial-checkbox-ticon"
        name="checkbox-radial-empty"
        :color="getColor(foreground_color)"
        :size="size"
        :shadow="shadow"
      />
    </TransitionFade>
  </button>
</template>

<script>
import TransitionFade from '@/components/WorkPackageWIP/TransitionFade.component.vue';
import TransitionRotate from '@/components/WorkPackageWIP/TransitionRotate.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';
import { TColor } from '@/mixins/TColor.mixin.js';

  export default {
    components: {
      TransitionFade,
      TransitionRotate,
      TIcon,
    },

    mixins: [TColor],

    props: [
      'id', // is string, is unique identifier
      'is_checked', // is boolean, toggles check mark display - must be controlled by parent
      'background_color', // is string, contains hexadecimal value of background NOTE: is only active when color_fill is set
      'foreground_color', // is string, contains hexadecimal value of text, outlines etc.
      'shadow', // is string, contains some sort of color (hex, rgb, vuetify)

      /* NOTE: legacy props - use "large", "giant", "color_fill" or "disabled" instead! */
      // 'is_large',
      // 'is_giant',
      // 'color_fill',
      // 'disabled',
    ],

    computed: {
      size() {
        let a = this.$attrs;
        if(a.giant !== undefined) {
          if(a.giant || a.giant === '') {
            return 40;
          }
        }
        if(a.large !== undefined) {
          if(a.large || a.large === '') {
            return 36;
          }
        }
        return 28;
      },

      fill_size() {
        let a = this.$attrs;
        if(a.giant !== undefined) {
          if(a.giant || a.giant === '') {
            return 29;
          }
        }
        if(a.large !== undefined) {
          if(a.large || a.large === '') {
            return 26;
          }
        }
        return 20;
      },

      color_fill() {
        let a = this.$attrs;
        if(a.color_fill !== undefined) {
          if(a.color_fill || a.color_fill === '') {
            return true;
          }
        }
        return false;
      },

      disabled() {
        let a = this.$attrs;
        if(a.disabled !== undefined) {
          if(a.disabled || a.disabled === '') {
            return true;
          }
        }
        return false;
      },
    },

    methods: {
      emit() {
        if(!this.disabled) {
          this.$emit('setActive', this.id);
        }
      },
    },

    data: () => ({

    }),
  }
</script>

<style>
  .radial-checkbox {
    width: 24px;
    height: 24px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    outline: none;
    flex-shrink: 0;
  }
  .radial-checkbox-ticon {
    position: absolute;
  }
  .radial-checkbox-color-fill {
    border-radius: 100%;
    position: absolute;
  }
</style>
